import React, { useEffect, useContext } from 'react';
import {
  node,
  bool,
  string,
} from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';

const CheckNearByStore = (props) => {
  const { channel, isConsumerApp } = useContext(ExperienceContext);
  const {
    itemId,
    children,
    isShipToHomeEligible
  } = props;
  let host = 'https://www.homedepot.com';
  if (typeof window !== 'undefined') {
    host = window.location.origin.match(/local/g)
      ? window.location.origin : 'https://www.homedepot.com';
  }

  const { storeId } = useStore();

  const cartReqParams = {
    itemId,
    host,
    keyword: storeId,
    channel,
    isShipToHomeEligible,
    alterBrowserHistory: true
  };

  function triggerSelectStore(event) {
    event.stopPropagation();
    event.preventDefault();
    window.LIFE_CYCLE_EVENT_BUS.trigger('cart.select-store', {
      cartReqParams
    });
  }

  return (
    <span
      role="button"
      tabIndex={0}
      className={isConsumerApp ? 'fulfillment__header_link' : 'u__default-link pointer'}
      onClick={triggerSelectStore}
      data-testid="check-nearby-stores-link"
    >
      {children}
    </span>
  );
};

CheckNearByStore.propTypes = {
  itemId: string.isRequired,
  children: node.isRequired,
  isShipToHomeEligible: bool,
};

CheckNearByStore.defaultProps = {
  isShipToHomeEligible: false
};

export { CheckNearByStore };
